import React, { useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/login.css';
import axios from 'axios';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Layouts - Not needed anymore, using DashboardLayout directly in pages

// Auth Pages
import LoginPage from './pages/auth/LoginPage';
import RegisterPage from './pages/auth/RegisterPage';
import TwoFactorPage from './pages/auth/TwoFactorPage';

// Public Pages
import LandingPage from './pages/public/LandingPage';
import PublicMetadataEditorPage from './pages/public/PublicMetadataEditorPage';

// K/L Pages
import KLDashboard from './pages/kl/DashboardPage';
import KLDataList from './pages/kl/DataListPage';
import KLDataDetail from './pages/kl/DataDetailPage';
import KLUpload from './pages/kl/UploadPage';
import KLSuccess from './pages/kl/SuccessPage';

// Admin Pages
import AdminDashboard from './pages/admin/DashboardPage';
import AdminDataList from './pages/admin/DataListPage';
import AdminVerifyData from './pages/admin/VerifyDataPage';
import AdminVerifiedDataList from './pages/admin/VerifiedDataPage';
import AdminPublishedDataList from './pages/shared/PublikasiPage';
import AdminSuccess from './pages/admin/SuccessPage';

// Supervisor Pages
import SupervisorApproval from './pages/supervisor/ApprovalPage';

// Publikator Pages
import PublikatorDashboard from './pages/publikator/DashboardPage';
import PublikatorData from './pages/publikator/DataPublicationPage';
import PublikatorHistory from './pages/publikator/HistoryDataPage';

// Shared Pages
import ProfilePage from './pages/shared/ProfilePage';
import RekapDataPage from './pages/shared/RekapDataPage';
import NotFoundPage from './pages/shared/NotFoundPage';

// Management Pages
import UserManagement from './pages/management/UserManagementPage';
import DataManagement from './pages/management/DataManagementPage';
import CatalogPage from './pages/management/CatalogPage';

// Protected Route
import ProtectedRoute from './ProtectedRoute';

function App() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.state?.sessionExpired) {
      toast.warning('Session Anda telah habis. Silakan login kembali.', {
        style: {
          background: '#fff3cd',
          color: '#856404',
          border: '1px solid #ffc107'
        }
      });
    }
  }, [location]);

  useEffect(() => {
    const responseInterceptor = axios.interceptors.response.use(
      response => response,
      error => {
        if (error.response && error.response.status === 401) {
          localStorage.removeItem('token');
          navigate('/', { state: { sessionExpired: true } });
        }
        return Promise.reject(error);
      }
    );
    return () => {
      axios.interceptors.response.eject(responseInterceptor);
    };
  }, [navigate]);

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        style={{ zIndex: 999999 }}
        className="toast-container-custom"
      />
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<LandingPage />} />
       {/* <Route path="/public/metadata-editor" element={<PublicMetadataEditorPage />} /> */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        
        {/* Auth Routes */}
        <Route path="/auth/2fa" element={<ProtectedRoute requireAuth={true} require2FA={false}><TwoFactorPage /></ProtectedRoute>} />

        {/* K/L Routes (Role 1) */}
        <Route path="/kl" element={<ProtectedRoute requireAuth={true} require2FA={true} allowedRoles={[1]}><KLDashboard /></ProtectedRoute>} />
        <Route path="/kl/data" element={<ProtectedRoute requireAuth={true} require2FA={true} allowedRoles={[1]}><KLDataList /></ProtectedRoute>} />
        <Route path="/kl/data/:no_tiket" element={<ProtectedRoute requireAuth={true} require2FA={true} allowedRoles={[1]}><KLDataDetail /></ProtectedRoute>} />
        <Route path="/kl/upload" element={<ProtectedRoute requireAuth={true} require2FA={true} allowedRoles={[1]}><KLUpload /></ProtectedRoute>} />
        <Route path="/kl/success" element={<ProtectedRoute requireAuth={true} require2FA={true} allowedRoles={[1]}><KLSuccess /></ProtectedRoute>} />

        {/* Admin Routes (Role 0) */}
        <Route path="/admin" element={<ProtectedRoute requireAuth={true} require2FA={true} allowedRoles={[0, 2]}><AdminDashboard /></ProtectedRoute>} />
        <Route path="/admin/data" element={<ProtectedRoute requireAuth={true} require2FA={true} allowedRoles={[0, 2]}><AdminDataList /></ProtectedRoute>} />
        <Route path="/admin/verify/:no_tiket" element={<ProtectedRoute requireAuth={true} require2FA={true} allowedRoles={[0, 2]}><AdminVerifyData /></ProtectedRoute>} />
        <Route path="/admin/verified" element={<ProtectedRoute requireAuth={true} require2FA={true} allowedRoles={[0, 2]}><AdminVerifiedDataList /></ProtectedRoute>} />
        <Route path="/admin/published" element={<ProtectedRoute requireAuth={true} require2FA={true} allowedRoles={[0, 2]}><AdminPublishedDataList /></ProtectedRoute>} />
        <Route path="/admin/success" element={<ProtectedRoute requireAuth={true} require2FA={true} allowedRoles={[0, 2]}><AdminSuccess /></ProtectedRoute>} />

        {/* Supervisor Routes (Role 2) */}
        <Route path="/supervisor/approval/:no_tiket" element={<ProtectedRoute requireAuth={true} require2FA={true} allowedRoles={[0, 2]}><SupervisorApproval /></ProtectedRoute>} />

        {/* Publikator Routes (Role 3) */}
        <Route path="/publikator" element={<ProtectedRoute requireAuth={true} require2FA={true} allowedRoles={[3]}><PublikatorDashboard /></ProtectedRoute>} />
        <Route path="/publikator/data" element={<ProtectedRoute requireAuth={true} require2FA={true} allowedRoles={[3]}><PublikatorData /></ProtectedRoute>} />
        <Route path="/publikator/history" element={<ProtectedRoute requireAuth={true} require2FA={true} allowedRoles={[3]}><PublikatorHistory /></ProtectedRoute>} />
        <Route path="/publikator/catalog" element={<ProtectedRoute requireAuth={true} require2FA={true} allowedRoles={[3]}><CatalogPage /></ProtectedRoute>} />

        {/* Shared Routes */}
        <Route path="/profile" element={<ProtectedRoute requireAuth={true} require2FA={true} allowedRoles={[0, 1, 2, 3]}><ProfilePage /></ProtectedRoute>} />
        <Route path="/kl/profile" element={<ProtectedRoute requireAuth={true} require2FA={true} allowedRoles={[1]}><ProfilePage /></ProtectedRoute>} />
        <Route path="/admin/profile" element={<ProtectedRoute requireAuth={true} require2FA={true} allowedRoles={[0, 2]}><ProfilePage /></ProtectedRoute>} />
        <Route path="/supervisor/profile" element={<ProtectedRoute requireAuth={true} require2FA={true} allowedRoles={[0, 2]}><ProfilePage /></ProtectedRoute>} />
        <Route path="/publikator/profile" element={<ProtectedRoute requireAuth={true} require2FA={true} allowedRoles={[3]}><ProfilePage /></ProtectedRoute>} />
        <Route path="/rekapdata/:no_tiket" element={<ProtectedRoute requireAuth={true} require2FA={true} allowedRoles={[0, 1, 2, 3]}><RekapDataPage /></ProtectedRoute>} />

        {/* Management Routes */}
        <Route path="/management/users" element={<ProtectedRoute requireAuth={true} require2FA={true} allowedRoles={[0, 2]}><UserManagement /></ProtectedRoute>} />
        <Route path="/management/data" element={<ProtectedRoute requireAuth={true} require2FA={true} allowedRoles={[0, 2]}><DataManagement /></ProtectedRoute>} />
        <Route path="/management/catalog" element={<ProtectedRoute requireAuth={true} require2FA={true} allowedRoles={[0, 2]}><CatalogPage /></ProtectedRoute>} />
        
        {/* 404 Not Found - Must be the last route */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </>
  );
}

export default App;